import {
  axiosInstance as Repository,
  RESULT_CD,
  RepositoryError,
} from "../repository";

const RESOURCE = "/reset-password";

/* カスタム例外 */
class ResetPasswordRepositoryError extends RepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = ResetPasswordRepositoryError.getErrorCd();
  }

  static getErrorCd() {
    return "04000";
  }
}

class IlligalAccessError extends ResetPasswordRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = IlligalAccessError.getErrorCd();
  }

  static getErrorCd() {
    return "04001";
  }
}

class AuthCodeExpisedError extends ResetPasswordRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AuthCodeExpisedError.getErrorCd();
  }

  static getErrorCd() {
    return "04002";
  }
}

class AttemptsExceededError extends ResetPasswordRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AttemptsExceededError.getErrorCd();
  }

  static getErrorCd() {
    return "04003";
  }
}

class AdminUserNotFoundError extends ResetPasswordRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = AdminUserNotFoundError.getErrorCd();
  }

  static getErrorCd() {
    return "02003";
  }
}

class PasswordValidationError extends ResetPasswordRepositoryError {
  constructor(message) {
    super(message);
    this.name = this.constructor.name;
    this.errorCd = PasswordValidationError.getErrorCd();
  }

  static getErrorCd() {
    return "02004";
  }
}

const ResetPasswordRepository = {
  async startEmailVerification(email) {
    const response = await Repository.get(`${RESOURCE}/send-email-verification-code`, {
      params: {
        email,
      },
    });

    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new ResetPasswordRepositoryError();
    }

    const result = {
      accessKey: response.data.access_key,
    };
    return result;
  },
  async emailVerification(email, accessKey, authCode) {
    const requestParams = {
      email,
      access_key: accessKey,
      auth_code: authCode,
    };
    const response = await Repository.post(`${RESOURCE}/email-verification`, requestParams);
    const verificationResult = response.data.result_cd === RESULT_CD.SUCCESS;

    // 失敗であれば、内容に応じた例外を送出
    if (!verificationResult) {
      if (response.data.errors[0].error_cd === IlligalAccessError.getErrorCd()) {
        throw new IlligalAccessError();
      } else if (response.data.errors[0].error_cd === AuthCodeExpisedError.getErrorCd()) {
        throw new AuthCodeExpisedError();
      } else if (response.data.errors[0].error_cd === AttemptsExceededError.getErrorCd()) {
        throw new AttemptsExceededError();
      } else if (response.data.errors[0].error_cd === AdminUserNotFoundError.getErrorCd()) {
        throw new AdminUserNotFoundError();
      } else if (response.data.errors[0].error_cd === PasswordValidationError.getErrorCd()) {
        throw new PasswordValidationError();
      } else {
        throw new ResetPasswordRepositoryError();
      }
    }

    //　成功時はauthentication_idが返却
    return response.data.authentication_id;
  },

  async resetPassword(email, accessKey, authCode, password) {
    const response = await Repository.post(`${RESOURCE}`, {
      email,
      access_key: accessKey,
      auth_code: authCode,
      password,
    });

    // 処理に失敗したら予期せぬエラーを出す
    if (response.data.result_cd !== RESULT_CD.SUCCESS) {
      throw new ResetPasswordRepositoryError();
    }
  },
};

export {
  ResetPasswordRepository,
  ResetPasswordRepositoryError,
  IlligalAccessError,
  AttemptsExceededError,
  AuthCodeExpisedError,
  AdminUserNotFoundError,
  PasswordValidationError,
};
